import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

const FormModal = ({ 
    isOpen, 
    toggle, 
    title, 
    children, 
    handleSubmit, 
    handleDiscard 
}) => {
    return (
        <Modal isOpen={isOpen} toggle={toggle} backdrop="static" keyboard={false} centered>
            <ModalHeader toggle={false}>{title}</ModalHeader>
            <ModalBody>
                {children || <p>No content available</p>}
            </ModalBody>
            <ModalFooter>
                <Button color="danger" onClick={handleDiscard}>
                    Batal
                </Button>
                <Button color="primary" onClick={handleSubmit}>
                    Simpan
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default FormModal;
